import CityPage from "../CityPage";

export default function Hinsdale() {
  return <CityPage slug="hinsdale" />;
}
